const GalleryCommentsComponentEs = {
  placeholder: 'Escribe un comentario',
}

const GalleryCommentsComponentEsUS = {
  placeholder: 'Write a comment...',
}

export { GalleryCommentsComponentEs, GalleryCommentsComponentEsUS }
